import styled from 'styled-components';

export const CarrierLogo = styled.img`
  object-fit: contain;
  border-radius: 2px;
`;

export const CarrierName = styled.div`
  font-weight: 500;
`;
